(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pool-covers-top"]) return;
  try {
    
  $(document).ready(function(){
    $('.pool-cover__sizes-select').change(function(){
      var size = $(this).val();
	  if(size !== ''){
		var baseUrl = $(this).attr('data-base-url');
		var sizeParam = "&pf_t_pool_cover_size=pool_cover_size%3A" + size;
		var newUrl = baseUrl += sizeParam

		window.location.href = newUrl;
	  }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
